var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgentMapBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3008,
    height: 3008,
    viewBox: "0 0 3008 3008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41941",
    "data-name": "Group 41941",
    transform: "translate(22054 -8662)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_15803",
    "data-name": "Rectangle 15803",
    d: "M0,0H3008a0,0,0,0,1,0,0V2996a12,12,0,0,1-12,12H12a12,12,0,0,1-12-12V0A0,0,0,0,1,0,0Z",
    transform: "translate(-22054 8662)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2802",
    "data-name": "Line 2802",
    x2: 3000,
    transform: "translate(-22054 8726)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2855",
    "data-name": "Line 2855",
    x2: 3000,
    transform: "translate(-22054 8758)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2856",
    "data-name": "Line 2856",
    x2: 3000,
    transform: "translate(-22054 8790)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2857",
    "data-name": "Line 2857",
    x2: 3000,
    transform: "translate(-22054 8822)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2858",
    "data-name": "Line 2858",
    x2: 3000,
    transform: "translate(-22054 8854)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2859",
    "data-name": "Line 2859",
    x2: 3000,
    transform: "translate(-22054 8886)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2860",
    "data-name": "Line 2860",
    x2: 3000,
    transform: "translate(-22054 8918)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2861",
    "data-name": "Line 2861",
    x2: 3000,
    transform: "translate(-22054 8950)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2862",
    "data-name": "Line 2862",
    x2: 3000,
    transform: "translate(-22054 8982)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2863",
    "data-name": "Line 2863",
    x2: 3000,
    transform: "translate(-22054 9014)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2864",
    "data-name": "Line 2864",
    x2: 3000,
    transform: "translate(-22054 9046)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2865",
    "data-name": "Line 2865",
    x2: 3000,
    transform: "translate(-22054 9078)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2866",
    "data-name": "Line 2866",
    x2: 3000,
    transform: "translate(-22054 9110)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2867",
    "data-name": "Line 2867",
    x2: 3000,
    transform: "translate(-22054 9142)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2868",
    "data-name": "Line 2868",
    x2: 3000,
    transform: "translate(-22054 9174)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2869",
    "data-name": "Line 2869",
    x2: 3000,
    transform: "translate(-22054 9206)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2870",
    "data-name": "Line 2870",
    x2: 3000,
    transform: "translate(-22054 9238)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2871",
    "data-name": "Line 2871",
    x2: 3000,
    transform: "translate(-22054 9270)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2872",
    "data-name": "Line 2872",
    x2: 3000,
    transform: "translate(-22054 9302)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2873",
    "data-name": "Line 2873",
    x2: 3000,
    transform: "translate(-22054 9334)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2874",
    "data-name": "Line 2874",
    x2: 3000,
    transform: "translate(-22054 9366)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2875",
    "data-name": "Line 2875",
    x2: 3000,
    transform: "translate(-22054 9398)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2876",
    "data-name": "Line 2876",
    x2: 3000,
    transform: "translate(-22054 9430)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2877",
    "data-name": "Line 2877",
    x2: 3000,
    transform: "translate(-22054 9462)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2878",
    "data-name": "Line 2878",
    x2: 3000,
    transform: "translate(-22054 9494)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2879",
    "data-name": "Line 2879",
    x2: 3000,
    transform: "translate(-22054 9526)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2880",
    "data-name": "Line 2880",
    x2: 3000,
    transform: "translate(-22054 9558)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2882",
    "data-name": "Line 2882",
    x2: 3000,
    transform: "translate(-22054 8694)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2881",
    "data-name": "Line 2881",
    y2: 3000,
    transform: "translate(-21990 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2883",
    "data-name": "Line 2883",
    y2: 3000,
    transform: "translate(-21958 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2884",
    "data-name": "Line 2884",
    y2: 3000,
    transform: "translate(-21926 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2885",
    "data-name": "Line 2885",
    y2: 3000,
    transform: "translate(-21894 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2886",
    "data-name": "Line 2886",
    y2: 3000,
    transform: "translate(-21862 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2887",
    "data-name": "Line 2887",
    y2: 3000,
    transform: "translate(-21830 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2888",
    "data-name": "Line 2888",
    y2: 3000,
    transform: "translate(-21798 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2889",
    "data-name": "Line 2889",
    y2: 3000,
    transform: "translate(-21766 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2890",
    "data-name": "Line 2890",
    y2: 3000,
    transform: "translate(-21734 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2891",
    "data-name": "Line 2891",
    y2: 3000,
    transform: "translate(-21702 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2892",
    "data-name": "Line 2892",
    y2: 3000,
    transform: "translate(-21670 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2893",
    "data-name": "Line 2893",
    y2: 3000,
    transform: "translate(-21638 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2894",
    "data-name": "Line 2894",
    y2: 3000,
    transform: "translate(-21606 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2895",
    "data-name": "Line 2895",
    y2: 3000,
    transform: "translate(-21574 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2896",
    "data-name": "Line 2896",
    y2: 3000,
    transform: "translate(-21542 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2897",
    "data-name": "Line 2897",
    y2: 3000,
    transform: "translate(-21510 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2898",
    "data-name": "Line 2898",
    y2: 3000,
    transform: "translate(-21478 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2899",
    "data-name": "Line 2899",
    y2: 3000,
    transform: "translate(-21446 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2900",
    "data-name": "Line 2900",
    y2: 3000,
    transform: "translate(-21414 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2901",
    "data-name": "Line 2901",
    y2: 3000,
    transform: "translate(-21382 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2902",
    "data-name": "Line 2902",
    y2: 3000,
    transform: "translate(-21350 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2903",
    "data-name": "Line 2903",
    y2: 3000,
    transform: "translate(-21318 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2904",
    "data-name": "Line 2904",
    y2: 3000,
    transform: "translate(-21286 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2905",
    "data-name": "Line 2905",
    y2: 3000,
    transform: "translate(-21254 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2906",
    "data-name": "Line 2906",
    y2: 3000,
    transform: "translate(-21222 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2907",
    "data-name": "Line 2907",
    y2: 3000,
    transform: "translate(-21190 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2908",
    "data-name": "Line 2908",
    y2: 3000,
    transform: "translate(-21158 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2909",
    "data-name": "Line 2909",
    y2: 3000,
    transform: "translate(-21126 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2910",
    "data-name": "Line 2910",
    y2: 3000,
    transform: "translate(-21094 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2911",
    "data-name": "Line 2911",
    y2: 3000,
    transform: "translate(-21062 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2912",
    "data-name": "Line 2912",
    y2: 3000,
    transform: "translate(-21030 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2913",
    "data-name": "Line 2913",
    y2: 3000,
    transform: "translate(-20998 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2914",
    "data-name": "Line 2914",
    y2: 3000,
    transform: "translate(-20966 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2915",
    "data-name": "Line 2915",
    y2: 3000,
    transform: "translate(-20934 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2916",
    "data-name": "Line 2916",
    y2: 3000,
    transform: "translate(-20902 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2917",
    "data-name": "Line 2917",
    y2: 3000,
    transform: "translate(-20870 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2918",
    "data-name": "Line 2918",
    y2: 3000,
    transform: "translate(-20838 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2919",
    "data-name": "Line 2919",
    y2: 3000,
    transform: "translate(-20806 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2920",
    "data-name": "Line 2920",
    y2: 3000,
    transform: "translate(-20774 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2921",
    "data-name": "Line 2921",
    y2: 3000,
    transform: "translate(-20742 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2922",
    "data-name": "Line 2922",
    y2: 3000,
    transform: "translate(-20710 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2923",
    "data-name": "Line 2923",
    y2: 3000,
    transform: "translate(-20678 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2924",
    "data-name": "Line 2924",
    y2: 3000,
    transform: "translate(-20646 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2925",
    "data-name": "Line 2925",
    y2: 3000,
    transform: "translate(-20614 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2926",
    "data-name": "Line 2926",
    y2: 3000,
    transform: "translate(-20582 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2927",
    "data-name": "Line 2927",
    y2: 3000,
    transform: "translate(-20550 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2928",
    "data-name": "Line 2928",
    y2: 3000,
    transform: "translate(-20518 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2929",
    "data-name": "Line 2929",
    y2: 3000,
    transform: "translate(-20486 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2930",
    "data-name": "Line 2930",
    y2: 3000,
    transform: "translate(-20454 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2931",
    "data-name": "Line 2931",
    y2: 3000,
    transform: "translate(-20422 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2932",
    "data-name": "Line 2932",
    y2: 3000,
    transform: "translate(-20390 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2933",
    "data-name": "Line 2933",
    y2: 3000,
    transform: "translate(-20358 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2934",
    "data-name": "Line 2934",
    y2: 3000,
    transform: "translate(-22022 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2935",
    "data-name": "Line 2935",
    y2: 3000,
    transform: "translate(-20326 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2936",
    "data-name": "Line 2936",
    y2: 3000,
    transform: "translate(-20294 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2937",
    "data-name": "Line 2937",
    y2: 3000,
    transform: "translate(-20262 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2938",
    "data-name": "Line 2938",
    y2: 3000,
    transform: "translate(-20230 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2939",
    "data-name": "Line 2939",
    y2: 3000,
    transform: "translate(-20198 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2940",
    "data-name": "Line 2940",
    y2: 3000,
    transform: "translate(-20166 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2941",
    "data-name": "Line 2941",
    y2: 3000,
    transform: "translate(-20134 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2942",
    "data-name": "Line 2942",
    y2: 3000,
    transform: "translate(-20102 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2943",
    "data-name": "Line 2943",
    y2: 3000,
    transform: "translate(-20070 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2944",
    "data-name": "Line 2944",
    y2: 3000,
    transform: "translate(-20038 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2945",
    "data-name": "Line 2945",
    y2: 3000,
    transform: "translate(-20006 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2946",
    "data-name": "Line 2946",
    y2: 3000,
    transform: "translate(-19974 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2947",
    "data-name": "Line 2947",
    y2: 3000,
    transform: "translate(-19942 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2948",
    "data-name": "Line 2948",
    y2: 3000,
    transform: "translate(-19910 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2949",
    "data-name": "Line 2949",
    y2: 3000,
    transform: "translate(-19878 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2950",
    "data-name": "Line 2950",
    y2: 3000,
    transform: "translate(-19846 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2951",
    "data-name": "Line 2951",
    y2: 3000,
    transform: "translate(-19814 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2952",
    "data-name": "Line 2952",
    y2: 3000,
    transform: "translate(-19782 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2953",
    "data-name": "Line 2953",
    y2: 3000,
    transform: "translate(-19750 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2954",
    "data-name": "Line 2954",
    y2: 3000,
    transform: "translate(-19718 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2955",
    "data-name": "Line 2955",
    y2: 3000,
    transform: "translate(-19686 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2956",
    "data-name": "Line 2956",
    y2: 3000,
    transform: "translate(-19654 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2957",
    "data-name": "Line 2957",
    y2: 3000,
    transform: "translate(-19622 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2958",
    "data-name": "Line 2958",
    y2: 3000,
    transform: "translate(-19590 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2959",
    "data-name": "Line 2959",
    y2: 3000,
    transform: "translate(-19558 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2960",
    "data-name": "Line 2960",
    y2: 3000,
    transform: "translate(-19526 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2961",
    "data-name": "Line 2961",
    y2: 3000,
    transform: "translate(-19494 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2962",
    "data-name": "Line 2962",
    y2: 3000,
    transform: "translate(-19462 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2963",
    "data-name": "Line 2963",
    y2: 3000,
    transform: "translate(-19430 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2964",
    "data-name": "Line 2964",
    y2: 3000,
    transform: "translate(-19398 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2965",
    "data-name": "Line 2965",
    y2: 3000,
    transform: "translate(-19366 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2966",
    "data-name": "Line 2966",
    y2: 3000,
    transform: "translate(-19334 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2967",
    "data-name": "Line 2967",
    y2: 3000,
    transform: "translate(-19302 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2968",
    "data-name": "Line 2968",
    y2: 3000,
    transform: "translate(-19270 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2969",
    "data-name": "Line 2969",
    y2: 3000,
    transform: "translate(-19238 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2970",
    "data-name": "Line 2970",
    y2: 3000,
    transform: "translate(-19206 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2971",
    "data-name": "Line 2971",
    y2: 3000,
    transform: "translate(-19174 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2972",
    "data-name": "Line 2972",
    y2: 3000,
    transform: "translate(-19142 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2973",
    "data-name": "Line 2973",
    y2: 3000,
    transform: "translate(-19110 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2974",
    "data-name": "Line 2974",
    y2: 3000,
    transform: "translate(-19078 8662)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2975",
    "data-name": "Line 2975",
    x2: 3000,
    transform: "translate(-22054 9622)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2976",
    "data-name": "Line 2976",
    x2: 3000,
    transform: "translate(-22054 9654)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2977",
    "data-name": "Line 2977",
    x2: 3000,
    transform: "translate(-22054 9686)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2978",
    "data-name": "Line 2978",
    x2: 3000,
    transform: "translate(-22054 9718)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2979",
    "data-name": "Line 2979",
    x2: 3000,
    transform: "translate(-22054 9750)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2980",
    "data-name": "Line 2980",
    x2: 3000,
    transform: "translate(-22054 9782)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2981",
    "data-name": "Line 2981",
    x2: 3000,
    transform: "translate(-22054 9814)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2982",
    "data-name": "Line 2982",
    x2: 3000,
    transform: "translate(-22054 9846)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2983",
    "data-name": "Line 2983",
    x2: 3000,
    transform: "translate(-22054 9878)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2984",
    "data-name": "Line 2984",
    x2: 3000,
    transform: "translate(-22054 9910)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2985",
    "data-name": "Line 2985",
    x2: 3000,
    transform: "translate(-22054 9942)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2986",
    "data-name": "Line 2986",
    x2: 3000,
    transform: "translate(-22054 9974)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2987",
    "data-name": "Line 2987",
    x2: 3000,
    transform: "translate(-22054 10006)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2988",
    "data-name": "Line 2988",
    x2: 3000,
    transform: "translate(-22054 10038)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2989",
    "data-name": "Line 2989",
    x2: 3000,
    transform: "translate(-22054 10070)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2990",
    "data-name": "Line 2990",
    x2: 3000,
    transform: "translate(-22054 10102)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2991",
    "data-name": "Line 2991",
    x2: 3000,
    transform: "translate(-22054 10134)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2992",
    "data-name": "Line 2992",
    x2: 3000,
    transform: "translate(-22054 10166)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2993",
    "data-name": "Line 2993",
    x2: 3000,
    transform: "translate(-22054 10198)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2994",
    "data-name": "Line 2994",
    x2: 3000,
    transform: "translate(-22054 10230)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2995",
    "data-name": "Line 2995",
    x2: 3000,
    transform: "translate(-22054 10262)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2996",
    "data-name": "Line 2996",
    x2: 3000,
    transform: "translate(-22054 10294)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2997",
    "data-name": "Line 2997",
    x2: 3000,
    transform: "translate(-22054 10326)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2998",
    "data-name": "Line 2998",
    x2: 3000,
    transform: "translate(-22054 10358)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2999",
    "data-name": "Line 2999",
    x2: 3000,
    transform: "translate(-22054 10390)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3000",
    "data-name": "Line 3000",
    x2: 3000,
    transform: "translate(-22054 10422)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3001",
    "data-name": "Line 3001",
    x2: 3000,
    transform: "translate(-22054 10454)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3002",
    "data-name": "Line 3002",
    x2: 3000,
    transform: "translate(-22054 9590)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3003",
    "data-name": "Line 3003",
    x2: 3000,
    transform: "translate(-22054 10486)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3004",
    "data-name": "Line 3004",
    x2: 3000,
    transform: "translate(-22054 10518)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3005",
    "data-name": "Line 3005",
    x2: 3000,
    transform: "translate(-22054 10550)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3006",
    "data-name": "Line 3006",
    x2: 3000,
    transform: "translate(-22054 10582)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3007",
    "data-name": "Line 3007",
    x2: 3000,
    transform: "translate(-22054 10614)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3008",
    "data-name": "Line 3008",
    x2: 3000,
    transform: "translate(-22054 10678)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3009",
    "data-name": "Line 3009",
    x2: 3000,
    transform: "translate(-22054 10710)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3010",
    "data-name": "Line 3010",
    x2: 3000,
    transform: "translate(-22054 10742)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3011",
    "data-name": "Line 3011",
    x2: 3000,
    transform: "translate(-22054 10774)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3012",
    "data-name": "Line 3012",
    x2: 3000,
    transform: "translate(-22054 10806)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3013",
    "data-name": "Line 3013",
    x2: 3000,
    transform: "translate(-22054 10838)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3014",
    "data-name": "Line 3014",
    x2: 3000,
    transform: "translate(-22054 10870)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3015",
    "data-name": "Line 3015",
    x2: 3000,
    transform: "translate(-22054 10902)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3016",
    "data-name": "Line 3016",
    x2: 3000,
    transform: "translate(-22054 10934)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3017",
    "data-name": "Line 3017",
    x2: 3000,
    transform: "translate(-22054 10966)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3018",
    "data-name": "Line 3018",
    x2: 3000,
    transform: "translate(-22054 10998)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3019",
    "data-name": "Line 3019",
    x2: 3000,
    transform: "translate(-22054 11030)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3020",
    "data-name": "Line 3020",
    x2: 3000,
    transform: "translate(-22054 11062)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3021",
    "data-name": "Line 3021",
    x2: 3000,
    transform: "translate(-22054 11094)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3022",
    "data-name": "Line 3022",
    x2: 3000,
    transform: "translate(-22054 11126)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3023",
    "data-name": "Line 3023",
    x2: 3000,
    transform: "translate(-22054 11158)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3024",
    "data-name": "Line 3024",
    x2: 3000,
    transform: "translate(-22054 11190)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3025",
    "data-name": "Line 3025",
    x2: 3000,
    transform: "translate(-22054 11222)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3026",
    "data-name": "Line 3026",
    x2: 3000,
    transform: "translate(-22054 11254)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3027",
    "data-name": "Line 3027",
    x2: 3000,
    transform: "translate(-22054 11286)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3028",
    "data-name": "Line 3028",
    x2: 3000,
    transform: "translate(-22054 11318)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3029",
    "data-name": "Line 3029",
    x2: 3000,
    transform: "translate(-22054 11350)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3030",
    "data-name": "Line 3030",
    x2: 3000,
    transform: "translate(-22054 11382)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3031",
    "data-name": "Line 3031",
    x2: 3000,
    transform: "translate(-22054 11414)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3032",
    "data-name": "Line 3032",
    x2: 3000,
    transform: "translate(-22054 11446)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3033",
    "data-name": "Line 3033",
    x2: 3000,
    transform: "translate(-22054 11478)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3034",
    "data-name": "Line 3034",
    x2: 3000,
    transform: "translate(-22054 11510)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3035",
    "data-name": "Line 3035",
    x2: 3000,
    transform: "translate(-22054 10646)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3036",
    "data-name": "Line 3036",
    x2: 3000,
    transform: "translate(-22054 11542)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3037",
    "data-name": "Line 3037",
    x2: 3000,
    transform: "translate(-22054 11574)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3038",
    "data-name": "Line 3038",
    x2: 3000,
    transform: "translate(-22054 11606)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3039",
    "data-name": "Line 3039",
    x2: 3000,
    transform: "translate(-22054 11638)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentMapBg);
export default __webpack_public_path__ + "static/media/agent-map-bg.2c3735aeb8b3db97daef925a3f4b92fe.svg";
export { ForwardRef as ReactComponent };